import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/index';
import { ActivatedRoute, Router } from '@angular/router';
import { animate, style, transition, trigger } from '@angular/animations';
import { User } from '../../../auth/user.model';
import { Order } from '../../order.model';
import { AuthService } from '../../../auth/auth.service';
import { UIService } from '../../../shared/ui.service';
import { OrderService } from '../../order.service';


@Component({
  selector: 'app-pickup-details',
  templateUrl: './pickup-details.component.html',
  styleUrls: ['./pickup-details.component.css'],
  animations: [
    trigger('fade', [
      transition('void => *', [
        style({backgroundColor: 'yellow', opacity: 0, height: '0px'}),
        animate(2000)
      ])
    ])
  ]
})

export class PickupDetailsComponent implements  OnInit, OnDestroy {
  user: User;
  order: Order;
  isLoading = false;

  lat = 51.678418;
  lng = 7.809007;

  private loadingSubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private orderService: OrderService,
    private authentication: AuthService,
    private uiService: UIService,
  ) { }



  ngOnInit() {

    this.loadingSubscription = this.uiService.loadingStateChanged.subscribe(isLoading => {
      this.isLoading = isLoading;
    });

    this.user = this.authentication.getUser();
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      console.log(id);
      this.orderService.getPickupOrderById(this.user.token, id).subscribe((result: Order) => {
        this.order = result;
        this.uiService.loadingStateChanged.next(false);
      });
    });
  }

  ngOnDestroy(): void {
    this.loadingSubscription.unsubscribe();
  }
}
